export const BASE_MODULES_MOBILE = [
  {
    name: 'login',
    active: {
      default: true,
    },
    visible: {
      default: true,
    },
    footer: {
      default: false,
    },
    header: {
      default: false,
    },
    datePicker: {
      default: false,
    },
    pullToRefresh: {
      default: false,
    },
    needsAuth: false,
    apis: {
      default: [
        'AppConfigResolver',
      ],
    },

    widgets: {
      default: [
        {
          id: 'ApiLogin',
          type: 'login',
          widgetsData: {
            title: 'Acceso',
            subtitle: 'Accedi a tuo account',
            inputs: [
              {
                name: 'email',
                label: 'Inserisci il tuo indirizzo email',
                type: 'email',
              },
              {
                name: 'password',
                label: 'Inserisci la  password',
                type: 'password',
                icon: 'hide',
              },
            ],
            buttonLabel: 'Accesso',
            footer: {
              label: 'Non hai un account?',
              buttonLabel: 'Iscriviti',
            },
            containedLabelTextfield: false,
            textfieldColor: 'white',
          },
          className: 'p-1',
          devID: 'jubilant-nacho',
          devPath: 'login->default->ApiLogin',
        },
      ],
    },
  },
  {
    name: 'forgot-password-mobile',
    active: {
      default: true,
    },
    visible: {
      default: true,
    },
    footer: {
      default: false,
    },
    header: {
      default: false,
    },
    datePicker: {
      default: false,
    },
    pullToRefresh: {
      default: false,
    },
    needsAuth: false,
    apis: {
      default: [
        'AppConfigResolver',
      ],
    },

    widgets: {
      default: [
        {
          className: 'p-1',
          id: 'forgot-password-mobile',
          type: 'forgot-password-mobile',
          widgetsData: {
            title: 'Acceso',
            subtitle: 'Accedi a tuo account',
            inputs: [
              {
                name: 'email',
                label: 'Inserisci il tuo indirizzo email',
                type: 'email',
              },
              {
                name: 'password',
                label: 'Inserisci la  password',
                type: 'password',
                icon: 'hide',
              },
            ],
            buttonLabel: 'Accesso',
            footer: {
              label: 'Non hai un account?',
              buttonLabel: 'Iscriviti',
            },
            containedLabelTextfield: false,
            textfieldColor: 'white',
          },
          devID: 'silly-cat',
          devPath: 'forgot-password-mobile->default->forgot-password-mobile',
        },
      ],
    },
  },
  {
    name: 'register',
    active: {
      default: true,
    },
    visible: {
      default: false,
    },
    footer: {
      default: false,
    },
    header: {
      default: false,
    },
    datePicker: {
      default: false,
    },
    pullToRefresh: {
      default: false,
    },
    needsAuth: false,
    apis: {
      default: [
        'AppConfigResolver',
      ],
    },

    widgets: {
      default: [
        {
          className: 'p-1',
          id: 'register',
          type: 'register',
          widgetsData: {
            title: 'pages.register.title',
            subtitle: 'pages.register.subtitle',
            inputs: {
              Stage_1: [
                {
                  name: 'billNumber',
                  label: 'pages.register.bill_number',
                  placeholder: 'pages.register.bill_number_placeholder',
                  action: 'pages.register.bill_number_action',
                  type: 'text',
                },

                {
                  name: 'customerNumber',
                  label: 'pages.register.customer_number',
                  placeholder: 'pages.register.customer_number_placeholder',
                  action: 'pages.register.customer_number_action',
                  type: 'text',
                },
              ],
              Stage_2: [
                {
                  name: 'email',
                  label: 'pages.register.email',
                  placeholder: 'pages.register.email_placeholder',
                  type: 'email',
                },
                {
                  name: 'password',
                  label: 'pages.register.password',
                  placeholder: 'pages.register.password_placeholder',
                  type: 'password',
                },
                {
                  name: 'confirmPassword',
                  label: 'pages.register.confirm_password',
                  placeholder: 'pages.register.confirm_password_placeholder',
                  type: 'password',
                },
              ],
            },
            buttonLabel: 'pages.register.button_label',
            footer: {
              label: 'pages.register.footer.label',
              buttonLabel: 'pages.register.footer.button_label',
            },
            containedLabelTextfield: false,
            textfieldColor: 'white',
          },
          containedLabelTextfield: false,
          textfieldColor: 'white',
          devID: 'rampaging-cactus',
          devPath: 'register->default->register',
        },
      ],
    },
  },
  {
    name: 'household',
    backgroundColor: {
      default: '#f7f7f7', // Standard background
    },
    active: {
      default: true,
    },
    visible: {
      default: true,
    },
    footer: {
      default: false,
    },
    header: {
      default: false,
    },
    datePicker: {
      default: false,
    },
    pullToRefresh: {
      default: true,
    },
    needsAuth: true,
    needsID: true,
    apis: {
      default: [
        'AppConfigResolver',
        'EntitiesResolver',
        'SiteOverviewResolver',
        'EnergyKpiSiteResolver',
        'AncillaryKpiSiteResolver',
        'EconomicsKpiSiteResolver',
        'EnergyCustomKpiSiteResolver',
        'EconomicsCustomKpiSiteResolver',
      ],
    },
    widgets: {
      default: [
        {
          order: 0,
          type: 'header',
          id: 'header',
          widgetName: 'header enduser producer',
          profileSections: [
            {
              key: 'ACCOUNT',
              icon: 'account',
              label: 'pages.profile.account.title',
              backgroundColor: '#ffffff',
              content: {
                title: 'pages.profile.account.title',
                subtitle: 'pages.profile.account.subtitle',
                backgroundColor: '#f7f7f7',
                textfields: [
                  {
                    label: 'pages.profile.account.name',
                    value: 'name',
                    type: 'text',
                    containedLabelTextfield: false,
                    textfieldColor: 'white',
                    placeholder: 'pages.profile.account.name_placeholder',
                  },
                  {
                    label: 'pages.profile.account.email',
                    value: 'email',
                    type: 'text',
                    containedLabelTextfield: false,
                    textfieldColor: 'white',
                    placeholder: 'pages.profile.account.email_placeholder',
                  },
                  {
                    label: 'pages.profile.account.password',
                    value: 'password',
                    type: 'password',
                    containedLabelTextfield: false,
                    textfieldColor: 'white',
                    placeholder: 'pages.profile.account.password_placeholder',
                  },
                  {
                    label: 'pages.profile.account.confirm_password',
                    value: 'confirmPassword',
                    type: 'password',
                    containedLabelTextfield: false,
                    textfieldColor: 'white',
                    placeholder:
                      'pages.profile.account.confirm_password_placeholder',
                  },
                ],
                confirmButton: 'pages.profile.account.confirm',
                deleteButton: 'pages.profile.account.delete',
              },
            },
            {
              key: 'FEEDBACK',
              icon: 'feedback_star',
              label: 'pages.profile.feedback.title',
              backgroundColor: '#ffffff',
              content: {
                title: 'pages.profile.feedback.title',
                subtitle: 'pages.profile.feedback.subtitle',
                backgroundColor: '#f7f7f7',
                label_1: 'pages.profile.feedback.label_1',
                label_2: 'pages.profile.feedback.label_2',
                label_3: 'pages.profile.feedback.label_3',
                terms: 'pages.profile.feedback.terms',
                comment_label: 'pages.profile.feedback.comment_label',
                confirmButton: 'pages.profile.feedback.confirmButton',
                buttonDescription: 'pages.profile.feedback.button_description',
                confirmationTitle: 'pages.profile.feedback.confirmation_title',
                confirmationDescription:
                  'pages.profile.feedback.confirmationDescription',
                thankYou: 'pages.profile.feedback.thankYou',
                doneButton: 'pages.profile.feedback.doneButton',
              },
            },
            {
              key: 'ABOUT',
              icon: 'legal',
              label: 'pages.profile.about.title',
              backgroundColor: '#ffffff',
              content: {
                title: 'pages.profile.about.title',
                subtitle: 'pages.profile.about.subtitle',
                backgroundColor: '#f7f7f7',
                dataProtection: 'pages.profile.about.data_protection',
                terms: 'pages.profile.about.terms',
                sections: [
                  'pages.profile.about.section_1',
                  'pages.profile.about.section_2',
                ],
              },
            },
          ],
          devID: 'rowdy-generala',
          devPath: 'household->default->header',
        },
        {
          className: 'px-1 mt-12_5 custom',
          order: 1,
          type: 'card',
          gradientBorder: false,
          subtype: 'consumptionCard',
          id: 'consumptionCard',
          totalValue: 'consumption',
          icon: 'self_sufficiency',
          descriptionType: 'label',
          description: 'widgets.consumptionCard.description.consumer',
          detail: false,
          devID: 'zany-igloo',
          devPath: 'household->default->consumptionCard',
        },
        {
          order: 2,
          className: 'px-1 pt-1_5',
          type: 'graphs',
          gradientBorder: false,
          subtype: 'consumptionStackBar',
          id: 'consumptionStackBar',
          totalValue: 'consumption',
          graphKeys: [
            {
              key: 'from_shared',
              color: 'from_shared',
              combined: true,
              base: false,
            },
            {
              key: 'from_grid',
              color: 'from_grid',
              combined: true,
              base: true,
            },
          ],
          colors: ['from_shared', 'consumption'],
          title: 'widgets.consumptionStackBar.title',
          devID: 'ferocious-davide',
          devPath: 'household->default->consumptionStackBar',
        },
        {
          order: 3,
          className: 'px-1 pt-1_5',

          type: 'card',
          gradientBorder: false,
          subtype: 'sharedEnergyCard',
          id: 'sharedEnergyCard',
          totalValue: 'total_shared',
          icon: 'shared_energy',
          descriptionType: 'description',
          description: 'widgets.sharedEnergyCard.description.consumer',
          details: {
            type: 'label',
            title: 'widgets.sharedEnergyCard.details.title',
            totalValue: 'total_shared',
            label_1: 'widgets.sharedEnergyCard.details.label',
          },
          devID: 'oddball-enchilada',
          devPath: 'household->default->sharedEnergyCard',
        },
        {
          order: 4,
          className: 'px-1 pt-1_5',

          type: 'card',
          gradientBorder: false,
          subtype: 'savingsCard',
          id: 'savingsCard',
          totalValue: 'total_benefits',
          icon: 'savings',
          descriptionType: 'label',
          description: 'widgets.savingsCard.description.consumer',
          kpiContext: 'economics',
          details: {
            type: 'detailed',
            title: 'widgets.savingsCard.details.consumer.title',
            totalValue: 'total_benefits',
            subtitle: 'widgets.savingsCard.subtitle',
            label_revenues:
              'widgets.savingsCard.details.consumer.label_revenues',
            label_savings: 'widgets.savingsCard.details.consumer.label_savings',
            data: [
              {
                label: 'widgets.savingsCard.details.consumer.label_1',
                value: 'public_incentive',
              },
              {
                label: 'widgets.savingsCard.details.consumer.label_2',
                value: 'charge_reduction_total',
              },
            ],
          },
          devID: 'peculiar-shirt',
          devPath: 'household->default->savingsCard',
        },
        {
          order: 5,
          className: 'px-1 pt-1_5',

          type: 'graphs',
          gradientBorder: false,
          subtype: 'savingsStackbar',
          kpiContext: 'economics',
          id: 'savingsStackbar',
          totalValue: 'total_benefits',
          graphKeys: [
            {
              key: 'revenues',
              color: 'revenues',
              combined: false,
            },
          ],
          colors: ['economics'],
          title: 'widgets.savingsStackbar.title',
          devID: 'quirksome-vortex',
          devPath: 'household->default->savingsStackbar',
        },
        {
          order: 6,
          className: 'px-1 pt-1_5',
          type: 'card',
          gradientBorder: false,
          kpiContext: 'ancillary',
          subtype: 'pollutionCard',
          id: 'pollutionCard',
          totalValue: 'co2_offset_kgs',
          trees: 'co2_offset_trees',
          icon: 'pollution',
          descriptionValue: 'co2_offset_trees',
          descriptionType: '{{trees}}',
          description: {
            line_1: 'widgets.pollutionCard.description.consumer.line_1',
            line_2: 'widgets.pollutionCard.description.consumer.line_2',
          },
          details: {
            type: 'labels+values',
            kpiContext: 'ancillary',
            title: 'widgets.pollutionCard.details.title',
            totalValue: 'co2_offset_kgs',
            data: [
              {
                label_1: 'widgets.pollutionCard.details.label',
                value_1: 'widgets.pollutionCard.details.value_1',
              },
              {
                label_2_1: 'widgets.pollutionCard.details.label_2_1',
                label_2_2: 'widgets.pollutionCard.details.label_2_2',
                value_1: 'co2_offset_trees',
                value_2: 'widgets.pollutionCard.details.value_2',
              },
            ],
          },
          devID: 'ferocious-pan',
          devPath: 'household->default->pollutionCard',
        },
        {
          order: 9999,
          type: 'footer',
          subtype: 'footer',
          id: 'footer',
          sections: ['household', 'community'],
          devID: 'nutty-nacho',
          devPath: 'household->default->footer',
        },
      ],
      'org:admin': {
        consumer: [],
        prosumer: [
          {
            id: 'consumptionCard',
            keep: false,
            devID: 'wild-buffet',
            devPath: 'household->org:admin->prosumer->consumptionCard',
          },
          {
            order: 1,
            className: ' mt-8_5',
            type: 'statsOverview',
            subtype: 'statsOverview',
            id: 'statsOverviewConsumption',
            totalValue: 'consumption',
            color: 'consumption',
            graphDataKeys: [
              {
                key: 'from_grid',
                label: 'widgets.statsOverview.consumption.from_network',
              },
              {
                key: 'self_consumption_direct',
                label: 'widgets.statsOverview.consumption.self_consumption',
              },
            ],
            graphColors: ['consumption', 'self_consumption'],
            title: 'widgets.statsOverview.consumption.title',
            values: [
              {
                label: 'widgets.statsOverview.consumption.self_consumption',
                totalPercentage: 'consumption_self_consumption_direct_rate',
                id: 'self_consumption_direct',
                progress: [
                  {
                    value: 'consumption_self_consumption_direct_rate',
                    color: 'self_consumption',
                    className:
                      '_StatsOverview__MultiProgress__Element_15aj1_100',
                  },
                ],
              },
              {
                label: 'widgets.statsOverview.consumption.from_network',
                totalPercentage: 'consumption_from_grid_rate',
                id: 'from_grid',
                progress: [
                  {
                    value: 'consumption_self_consumption_direct_rate',
                    color: '#F0F0F0',
                    className:
                      '_StatsOverview__MultiProgress__Element_15aj1_100',
                  },
                  {
                    value: 'consumption_from_grid_rate',
                    color: 'consumption',
                    className:
                      '_StatsOverview__MultiProgress__Element_15aj1_100',
                  },
                ],
              },
            ],
            devID: 'zippy-glove',
            devPath: 'household->org:admin->prosumer->statsOverviewConsumption',
          },
          {
            order: 2,
            // className: ' pt-1_5',

            type: 'statsOverview',
            subtype: 'statsOverview',
            id: 'statsOverviewProduction',
            totalValue: 'production',
            color: 'production',
            graphDataKeys: [
              {
                key: 'self_consumption_direct',
                label: 'widgets.statsOverview.production.self_consumption',
              },
              {
                key: 'to_grid',
                label: 'widgets.statsOverview.production.to_network',
              },
            ],
            graphColors: ['self_consumption', 'production'],
            title: 'widgets.statsOverview.production.title',
            values: [
              {
                label: 'widgets.statsOverview.production.self_consumption',
                totalPercentage: 'production_self_consumption_direct_rate',
                id: 'self_consumption_direct',
                progress: [
                  {
                    value: 'production_self_consumption_direct_rate',
                    color: 'self_consumption',
                    className:
                      '_StatsOverview__MultiProgress__Element_15aj1_100',
                  },
                ],
              },
              {
                label: 'widgets.statsOverview.production.to_network',
                totalPercentage: 'production_to_grid_rate',
                id: 'to_grid',
                progress: [
                  {
                    value: 'production_self_consumption_direct_rate',
                    color: '#F0F0F0',
                    className:
                      '_StatsOverview__MultiProgress__Element_15aj1_100',
                  },
                  {
                    value: 'production_to_grid_rate',
                    color: 'production',
                    className:
                      '_StatsOverview__MultiProgress__Element_15aj1_100',
                  },
                ],
              },
            ],
            devID: 'ludicrous-hamburger',
            devPath: 'household->org:admin->prosumer->statsOverviewProduction',
          },
          {
            order: 3,
            className: 'px-1 py-0_5 pt-xs-2',
            type: 'card',
            gradientBorder: false,
            subtype: 'sharedEnergyCard',
            id: 'sharedEnergyCard',
            totalValue: 'total_shared',
            icon: 'shared_energy',
            descriptionType: 'keyValue',
            description: [
              {
                key: 'widgets.sharedEnergyCard.description.prosumer.key_1',
                value: 'from_shared',
              },
              {
                key: 'widgets.sharedEnergyCard.description.prosumer.key_2',
                value: 'to_shared',
              },
            ],
            details: {
              type: 'label',
              title: 'widgets.sharedEnergyCard.details.title',
              totalValue: 'total_shared',
              label_1: 'widgets.sharedEnergyCard.details.label',
              value_1: 'from_shared',
              label_2: 'widgets.sharedEnergyCard.details.label_2',
              value_2: 'to_shared',
            },
            devID: 'zesty-mango',
            devPath: 'household->org:admin->prosumer->sharedEnergyCard',
          },
          {
            order: 4,
            className: 'px-1 pt-1',
            type: 'card',
            gradientBorder: false,
            subtype: 'savingsCard',
            kpiContext: 'economics',
            id: 'savingsCard',
            totalValue: 'total_benefits',
            icon: 'savings',
            descriptionType: 'label',
            description: 'widgets.savingsCard.description.consumer',
            details: {
              type: 'detailed',
              title: 'widgets.savingsCard.details.consumer.title',
              totalValue: 'total_benefits',
              subtitle: 'widgets.savingsCard.subtitle',
              label_revenues:
                'widgets.savingsCard.details.consumer.label_revenues',
              label_savings:
                'widgets.savingsCard.details.consumer.label_savings',
              data: [
                {
                  label: 'widgets.savingsCard.details.consumer.label_1',
                  value: 'public_incentive',
                },
                {
                  label: 'widgets.savingsCard.details.consumer.label_2',
                  value: 'charge_reduction_total',
                },
              ],
            },
            devID: 'clumsy-dragon',
            devPath: 'household->org:admin->prosumer->savingsCard',
          },
          {
            order: 5,
            className: 'px-1 pt-1_5',

            type: 'graphs',
            gradientBorder: false,
            subtype: 'savingsStackbar',
            kpiContext: 'economics',
            id: 'savingsStackbar',
            totalValue: 'total_benefits',
            graphKeys: [
              {
                key: 'revenues',
                color: 'revenues',
                combined: false,
              },
            ],
            colors: ['economics'],
            title: 'widgets.savingsStackbar.title',
            devID: 'angry-ferret',
            devPath: 'household->org:admin->prosumer->savingsStackbar',
          },
          {
            order: 6,
            className: 'px-1 pt-1_5',

            type: 'card',
            gradientBorder: false,
            subtype: 'selfSufficiencyCard',
            id: 'selfSufficiencyCard',
            totalValue: 'self_sufficiency_rate',
            icon: 'self_sufficiency',
            descriptionValue: 'self_consumption',
            descriptionType: 'value+label',
            description: 'widgets.selfSufficiencyCard.description.prosumer',
            details: {
              type: 'label+description',
              title: 'widgets.selfSufficiencyCard.details.title',
              totalValue: 'self_sufficiency_rate',
              label: 'widgets.selfSufficiencyCard.details.label',
              description_1:
                'widgets.selfSufficiencyCard.details.description_1',
              value_1: 'self_consumption',
              description_2:
                'widgets.selfSufficiencyCard.details.description_2',
              value_2: 'consumption',
            },
            devID: 'whacky-waffle',
            devPath: 'household->org:admin->prosumer->selfSufficiencyCard',
          },
          {
            order: 7,
            className: 'px-1 pt-1_5',

            id: 'pollutionCard',
            type: 'card',
            gradientBorder: false,
            kpiContext: 'ancillary',
            subtype: 'pollutionCard',
            totalValue: 'co2_offset_kgs',
            trees: 'co2_offset_trees',
            icon: 'pollution',
            descriptionValue: 'co2_offset_trees',
            descriptionType: '{{trees}}',
            description: {
              line_1: 'widgets.pollutionCard.description.prosumer.line_1',
              line_2: 'widgets.pollutionCard.description.prosumer.line_2',
            },
            details: {
              type: 'labels+values',
              kpiContext: 'ancillary',
              title: 'widgets.pollutionCard.details.title',
              totalValue: 'co2_offset_kgs',
              data: [
                {
                  label_1: 'widgets.pollutionCard.details.label',
                  value_1: 'widgets.pollutionCard.details.value_1',
                },
                {
                  label_2_1: 'widgets.pollutionCard.details.label_2_1',
                  label_2_2: 'widgets.pollutionCard.details.label_2_2',
                  value_1: 'co2_offset_trees',
                  value_2: 'widgets.pollutionCard.details.value_2',
                },
              ],
            },
            devID: 'mystical-jigsaw',
            devPath: 'household->org:admin->prosumer->pollutionCard',
          },
          {
            order: 8,
            className: 'px-1 pt-1_5',

            type: 'graphs',
            gradientBorder: false,
            subtype: 'consumptionStackBar',
            id: 'consumptionStackBar',
            totalValue: 'consumption',
            graphKeys: [
              {
                key: 'self_consumption_direct',
                color: 'self_consumption',
                combined: false,
              },
              {
                key: 'from_shared',
                color: 'from_shared',
                combined: true,
                base: false,
              },
              {
                key: 'from_grid',
                color: 'from_grid',
                combined: true,
                base: true,
              },
            ],
            colors: ['self_consumption', 'from_shared', 'from_grid'],
            title: 'widgets.consumptionStackBar.title',
            devID: 'whimsical-cabbage',
            devPath: 'household->org:admin->prosumer->consumptionStackBar',
          },
          {
            order: 9,
            className: 'px-1 pt-1_5',

            type: 'graphs',
            gradientBorder: false,
            subtype: 'productionStackBar',
            id: 'productionStackBar',
            totalValue: 'production',
            graphKeys: [
              {
                key: 'self_consumption_direct',
                color: 'self_consumption',
                combined: false,
              },
              {
                key: 'to_shared',
                color: 'to_shared',
                combined: true,
                base: false,
              },
              {
                key: 'to_grid',
                color: 'to_grid',
                combined: true,
                base: true,
              },
            ],
            colors: ['self_consumption', 'to_shared', 'production'],
            title: 'widgets.productionStackBar.title',
            devID: 'luminous-flamingo',
            devPath: 'household->org:admin->prosumer->productionStackBar',
          },
          {
            order: 10,
            className: 'px-1 pt-1_5',

            type: 'areachart',
            gradientBorder: false,
            subtype: 'areachart',
            id: 'areachart',
            graphKeys: ['consumption', 'production', 'self_consumption'],
            colors: ['consumption', 'production', 'self_consumption'],
            title: 'widgets.areaChart.self-consumption.title',
            devID: 'mystical-bear',
            devPath: 'household->org:admin->prosumer->areachart',
          },
        ],
        producer: [
          {
            id: 'consumptionCard',
            keep: false,
            devID: 'maniacal-saxophone',
            devPath: 'household->org:admin->producer->consumptionCard',
          },
          {
            id: 'savingsCard',
            keep: false,
            devID: 'jazzy-glove',
            devPath: 'household->org:admin->producer->savingsCard',
          },
          {
            id: 'sharedEnergyCard',
            keep: false,
            devID: 'nutty-marshmallow',
            devPath: 'household->org:admin->producer->sharedEnergyCard',
          },
          {
            id: 'consumptionStackBar',
            keep: false,
            devID: 'ludicrous-buffet',
            devPath: 'household->org:admin->producer->consumptionStackBar',
          },
          {
            id: 'pollutionCard',
            keep: false,
            devID: 'rampaging-zeppelin',
            devPath: 'household->org:admin->producer->pollutionCard',
          },
          {
            className: 'px-1 mt-12_5 custom',

            order: 1,
            type: 'card',
            gradientBorder: false,
            subtype: 'productionCard',
            id: 'productionCard',
            totalValue: 'production',
            icon: 'production',
            descriptionType: 'label',
            description: 'widgets.productionCard.description.producer',
            detail: false,
            devID: 'nutty-kangaroo',
            devPath: 'household->org:admin->producer->productionCard',
          },
          {
            order: 2,
            id: 'savingsCard',
            devID: 'silly-jellyfish',
            devPath: 'household->org:admin->producer->savingsCard',
          },
          {
            order: 3,
            className: 'px-1 pt-1_5',

            type: 'graphs',
            gradientBorder: false,
            subtype: 'productionStackBar',
            id: 'productionStackBar',
            totalValue: 'production',
            graphKeys: [
              {
                key: 'to_shared',
                color: 'to_shared',
                combined: true,
              },
              {
                key: 'to_grid',
                color: 'to',
                combined: true,
              },
            ],
            combinedKeys: [
              {
                key: 'to_shared',
                color: 'to_shared',
                combined: true,
              },
              {
                key: 'to_grid',
                color: 'to',
                combined: true,
              },
            ],
            colors: ['production', 'self_consumption'],
            title: 'widgets.productionStackBar.title',
            devID: 'fantastic-igloo',
            devPath: 'household->org:admin->producer->productionStackBar',
          },
        ],
        prosumage: [
          {
            id: 'consumptionCard',
            keep: false,
            devID: 'wondrous-gumball',
            devPath: 'household->org:admin->prosumage->consumptionCard',
          },
          {
            order: 1,
            className: ' mt-12_5 custom',

            type: 'statsOverview',
            subtype: 'statsOverview',
            id: 'statsOverviewConsumption',
            totalValue: 'consumption',
            color: 'consumption',
            graphDataKeys: [
              {
                key: 'self_consumption_direct',
                label: 'widgets.statsOverview.consumption.self_consumption',
              },
              {
                key: 'self_consumption_battery',
                label:
                  'widgets.statsOverview.consumption.self_consumption_battery',
              },
              {
                key: 'from_grid',
                label: 'widgets.statsOverview.consumption.from_network',
              },
            ],
            graphColors: [
              'self_consumption',
              'self_consumption_battery',
              'consumption',
            ],
            title: 'widgets.statsOverview.consumption.title',
            values: [
              {
                label: 'widgets.statsOverview.consumption.self_consumption',
                totalPercentage: 'consumption_self_consumption_direct_rate',
                id: 'self_consumption_direct',
                progress: [
                  {
                    value: 'consumption_self_consumption_direct_rate',
                    color: 'self_consumption',
                    className:
                      '_StatsOverview__MultiProgress__Element_15aj1_100',
                  },
                ],
              },
              {
                label:
                  'widgets.statsOverview.consumption.self_consumption_battery',
                totalPercentage: 'consumption_self_consumption_battery_rate',
                id: 'self_consumption_battery',
                progress: [
                  {
                    value: 'consumption_self_consumption_direct_rate',
                    color: '#F0F0F0',
                    className:
                      '_StatsOverview__MultiProgress__Element_15aj1_100',
                  },
                  {
                    value: 'consumption_self_consumption_battery_rate',
                    color: 'self_consumption_battery',
                    className:
                      '_StatsOverview__MultiProgress__Element_15aj1_100',
                  },
                ],
              },
              {
                label: 'widgets.statsOverview.consumption.from_network',
                totalPercentage: 'consumption_from_grid_rate',
                id: 'from_grid',
                progress: [
                  {
                    value: 'consumption_self_consumption_direct_rate',
                    color: '#F0F0F0',
                    className:
                      '_StatsOverview__MultiProgress__Element_15aj1_100',
                  },
                  {
                    value: 'consumption_self_consumption_battery_rate',
                    color: '#F0F0F0',
                    className:
                      '_StatsOverview__MultiProgress__Element_15aj1_100',
                  },
                  {
                    value: 'consumption_from_grid_rate',
                    color: 'consumption',
                    className:
                      '_StatsOverview__MultiProgress__Element_15aj1_100',
                  },
                ],
              },
            ],
            devID: 'vivacious-firecracker',
            devPath:
              'household->org:admin->prosumage->statsOverviewConsumption',
          },
          {
            order: 2,
            className: ' pt-1_5',

            type: 'statsOverview',
            subtype: 'statsOverview',
            id: 'statsOverviewProduction',
            totalValue: 'production',
            color: 'production',
            graphDataKeys: [
              {
                key: 'self_consumption_direct',
                label: 'widgets.statsOverview.production.self_consumption',
              },
              {
                key: 'production_to_battery',
                label:
                  'widgets.statsOverview.production.self_consumption_battery',
              },
              {
                key: 'to_grid',
                label: 'widgets.statsOverview.production.from_network',
              },
            ],
            graphColors: ['self_consumption', 'battery', 'production'],
            title: 'widgets.statsOverview.production.title',
            values: [
              {
                label: 'widgets.statsOverview.production.self_consumption',
                totalPercentage: 'production_self_consumption_direct_rate',
                id: 'self_consumption_direct',
                progress: [
                  {
                    value: 'production_self_consumption_direct_rate',
                    color: 'self_consumption',
                    className:
                      '_StatsOverview__MultiProgress__Element_15aj1_100',
                  },
                ],
              },
              {
                label: 'widgets.statsOverview.production.from_battery',
                totalPercentage: 'production_to_battery_rate',
                id: 'production_to_battery',
                progress: [
                  {
                    value: 'production_self_consumption_direct_rate',
                    color: '#F0F0F0',
                    className:
                      '_StatsOverview__MultiProgress__Element_15aj1_100',
                  },
                  {
                    value: 'production_to_battery_rate',
                    color: 'production_to_battery',
                    className:
                      '_StatsOverview__MultiProgress__Element_15aj1_100',
                  },
                ],
              },
              {
                label: 'widgets.statsOverview.production.from_network',
                totalPercentage: 'production_to_grid_rate',
                id: 'to_grid',
                progress: [
                  {
                    value: 'production_self_consumption_direct_rate',
                    color: '#F0F0F0',
                    className:
                      '_StatsOverview__MultiProgress__Element_15aj1_100',
                  },
                  {
                    value: 'production_to_battery_rate',
                    color: '#F0F0F0',
                    className:
                      '_StatsOverview__MultiProgress__Element_15aj1_100',
                  },
                  {
                    value: 'production_to_grid_rate',
                    color: 'production',
                    className:
                      '_StatsOverview__MultiProgress__Element_15aj1_100',
                  },
                ],
              },
            ],
            devID: 'cannibal-jellyfish',
            devPath: 'household->org:admin->prosumage->statsOverviewProduction',
          },
          {
            order: 3,
            className: 'px-1 py-0_5 pt-xs-2',
            type: 'card',
            gradientBorder: false,
            subtype: 'sharedEnergyCard',
            id: 'sharedEnergyCard',
            totalValue: 'total_shared',
            icon: 'shared_energy',
            descriptionType: 'keyValue',
            description: [
              {
                key: 'widgets.sharedEnergyCard.description.prosumage.key_1',
                value: 'from_shared',
              },
              {
                key: 'widgets.sharedEnergyCard.description.prosumage.key_2',
                value: 'to_shared',
              },
            ],
            details: {
              type: 'label',
              title: 'widgets.sharedEnergyCard.details.title',
              totalValue: 'total_shared',
              label_1: 'widgets.sharedEnergyCard.details.label',
              value_1: 'from_shared',
              label_2: 'widgets.sharedEnergyCard.details.label_2',
              value_2: 'to_shared',
            },
            devID: 'oddball-espresso',
            devPath: 'household->org:admin->prosumage->sharedEnergyCard',
          },
          {
            order: 4,
            className: 'px-1 pt-1',
            type: 'card',
            gradientBorder: false,
            subtype: 'savingsCard',
            kpiContext: 'economics',
            id: 'savingsCard',
            totalValue: 'total_benefits',
            icon: 'savings',
            descriptionType: 'label',
            description: 'widgets.savingsCard.description.prosumer',
            details: {
              type: 'detailed',
              title: 'widgets.savingsCard.details.prosumage.title',
              totalValue: 'total_benefits',
              subtitle: 'widgets.savingsCard.subtitle',
              label_revenues:
                'widgets.savingsCard.details.prosumage.label_revenues',
              label_savings:
                'widgets.savingsCard.details.prosumage.label_savings',
              data: [
                {
                  label: 'widgets.savingsCard.details.prosumage.label_1',
                  value: 'direct_compensation',
                },
                {
                  label: 'widgets.savingsCard.details.prosumage.label_2',
                  value: 'public_incentive',
                },
                {
                  label: 'widgets.savingsCard.details.prosumage.label_3',
                  value: 'charge_reduction',
                },
              ],
            },
            devID: 'clumsy-ferret',
            devPath: 'household->org:admin->prosumage->savingsCard',
          },
          {
            order: 5,
            id: 'savingsStackbar',
            totalValue: 'total_benefits',
            type: 'graphs',
            devID: 'rambunctious-flamingo',
            devPath: 'household->org:admin->prosumage->savingsStackbar',
          },
          {
            order: 6,
            className: 'px-1 pt-1_5',

            type: 'card',
            gradientBorder: false,
            subtype: 'selfSufficiencyCard',
            id: 'selfSufficiencyCard',
            totalValue: 'self_sufficiency_rate',
            icon: 'self_sufficiency',
            descriptionValue: 'self_consumption',
            descriptionType: 'value+label',
            description: 'widgets.selfSufficiencyCard.description.prosumage',
            details: {
              type: 'label+description',
              title: 'widgets.selfSufficiencyCard.details.title',
              totalValue: 'self_sufficiency_rate',
              label: 'widgets.selfSufficiencyCard.details.label',
              description_1:
                'widgets.selfSufficiencyCard.details.description_1',
              value_1: 'self_consumption',
              description_2:
                'widgets.selfSufficiencyCard.details.description_2',
              value_2: 'consumption',
            },
            devID: 'ferocious-vortex',
            devPath: 'household->org:admin->prosumage->selfSufficiencyCard',
          },
          {
            order: 7,
            className: 'px-1 pt-1_5',

            id: 'pollutionCard',
            type: 'card',
            gradientBorder: false,
            kpiContext: 'ancillary',
            subtype: 'pollutionCard',
            totalValue: 'co2_offset_kgs',
            trees: 'co2_offset_trees',
            icon: 'pollution',
            descriptionValue: 'co2_offset_trees',
            descriptionType: '{{trees}}',
            description: {
              line_1: 'widgets.pollutionCard.description.prosumage.line_1',
              line_2: 'widgets.pollutionCard.description.prosumage.line_2',
            },
            details: {
              type: 'labels+values',
              kpiContext: 'ancillary',
              title: 'widgets.pollutionCard.details.title',
              totalValue: 'co2_offset_kgs',
              data: [
                {
                  label_1: 'widgets.pollutionCard.details.label',
                  value_1: 'widgets.pollutionCard.details.value_1',
                },
                {
                  label_2_1: 'widgets.pollutionCard.details.label_2_1',
                  label_2_2: 'widgets.pollutionCard.details.label_2_2',
                  value_1: 'co2_offset_trees',
                  value_2: 'widgets.pollutionCard.details.value_2',
                },
              ],
            },
            devID: 'wild-gumball',
            devPath: 'household->org:admin->prosumage->pollutionCard',
          },
          {
            order: 8,
            className: 'px-1 pt-1_5',

            type: 'graphs',
            gradientBorder: false,
            subtype: 'consumptionStackBar', // Used for t(`widgets.${subtype}.${key}`)
            id: 'consumptionStackBar',
            title: 'widgets.consumptionStackBar.title',

            unit: 'kWh', // ADD THIS: The new component requires a unit, e.g., 'kWh'
            graphKeys: [
              // This structure is largely the same, `color` is the theme color key
              {
                key: 'self_consumption_direct',
                color: 'self_consumption',
                combined: false,
              },
              {
                key: 'self_consumption_battery',
                color: 'self_consumption_battery',
                combined: false,
              },
              {
                key: 'from_shared',
                color: 'from_shared',
                combined: true,
                base: false,
              },
              {
                key: 'from_grid',
                color: 'from_grid',
                combined: true,
                base: true,
              },
            ],
            colors: ['self_consumption', 'battery', 'consumption'],
            devID: 'zippy-mango',
            devPath: 'household->org:admin->prosumage->consumptionStackBar',
          },
          {
            order: 9,
            className: 'px-1 pt-1_5',

            type: 'graphs',
            gradientBorder: false,
            subtype: 'productionStackBar',
            id: 'productionStackBar',
            totalValue: 'production',
            graphKeys: [
              {
                key: 'self_consumption_direct',
                color: 'self_consumption',
                combined: false,
              },
              {
                key: 'production_to_battery',
                color: 'production_to_battery',
                combined: false,
              },
              {
                key: 'to_shared',
                color: 'to_shared',
                combined: true,
                base: false,
              },
              {
                key: 'to_grid',
                color: 'production',
                combined: true,
                base: true,
              },
            ],
            colors: ['self_consumption', 'production_to_battery', 'production'],
            title: 'widgets.productionStackBar.title',
            devID: 'clumsy-cabbage',
            devPath: 'household->org:admin->prosumage->productionStackBar',
          },
          {
            order: 10,
            className: 'px-1 pt-1_5',

            id: 'batteryChartMobile',
            title: 'widgets.batteryChart.title',
            type: 'graphs',
            subtype: 'batteryChartMobile',
            gradientBorder: false,
            context: 'site',
            buttons: [
              'widgets.batteryChart.self_consumption_battery',
              'widgets.batteryChart.production_to_battery',
              'widgets.batteryChart.soc',
            ],
            colors: [
              {
                color: 'self_consumption_battery',
                colorShade: '',
              },
              {
                color: 'production_to_battery',
                colorShade: '',
              },
              {
                color: 'soc_battery',
                colorShade: '',
              },
            ],
            db_fields: [
              'self_consumption_battery',
              'production_to_battery',
              'soc_battery',
            ],
            devID: 'glowing-iceberg',
            devPath: 'household->org:admin->prosumage->batteryChartMobile',
          },
          {
            order: 11,
            className: 'px-1 pt-1_5',

            type: 'areachart',
            gradientBorder: false,
            subtype: 'areachart',
            id: 'areachart',
            graphKeys: ['consumption', 'production', 'self_consumption'],
            colors: ['consumption', 'production', 'self_consumption'],
            title: 'widgets.areaChart-self-consumption.title',
            devID: 'impish-marshmallow',
            devPath: 'household->org:admin->prosumage->areachart',
          },
        ],
      },
      enduser: {
        consumer: [],
        prosumer: [
          {
            id: 'consumptionCard',
            keep: false,
            devID: 'silly-pajamas',
            devPath: 'household->enduser->prosumer->consumptionCard',
          },
          {
            order: 1,
            className: ' mt-12_5 custom',

            type: 'statsOverview',
            subtype: 'statsOverview',
            id: 'statsOverviewConsumption',
            totalValue: 'consumption',
            color: 'consumption',
            graphDataKeys: [
              {
                key: 'from_grid',
                label: 'widgets.statsOverview.consumption.from_network',
              },
              {
                key: 'self_consumption_direct',
                label: 'widgets.statsOverview.consumption.self_consumption',
              },
            ],
            graphColors: ['consumption', 'self_consumption'],
            title: 'widgets.statsOverview.consumption.title',
            values: [
              {
                label: 'widgets.statsOverview.consumption.self_consumption',
                totalPercentage: 'consumption_self_consumption_direct_rate',
                id: 'self_consumption_direct',
                progress: [
                  {
                    value: 'consumption_self_consumption_direct_rate',
                    color: 'self_consumption',
                    className:
                      '_StatsOverview__MultiProgress__Element_15aj1_100',
                  },
                ],
              },
              {
                label: 'widgets.statsOverview.consumption.from_network',
                totalPercentage: 'consumption_from_grid_rate',
                id: 'from_grid',
                progress: [
                  {
                    value: 'consumption_self_consumption_direct_rate',
                    color: '#F0F0F0',
                    className:
                      '_StatsOverview__MultiProgress__Element_15aj1_100',
                  },
                  {
                    value: 'consumption_from_grid_rate',
                    color: 'consumption',
                    className:
                      '_StatsOverview__MultiProgress__Element_15aj1_100',
                  },
                ],
              },
            ],
            devID: 'giddy-zeppelin',
            devPath: 'household->enduser->prosumer->statsOverviewConsumption',
          },
          {
            order: 2,
            className: ' pt-1_5',

            type: 'statsOverview',
            subtype: 'statsOverview',
            id: 'statsOverviewProduction',
            totalValue: 'production',
            color: 'production',
            graphDataKeys: [
              {
                key: 'self_consumption_direct',
                label: 'widgets.statsOverview.production.self_consumption',
              },
              {
                key: 'to_grid',
                label: 'widgets.statsOverview.production.to_network',
              },
            ],
            graphColors: ['self_consumption', 'production'],
            title: 'widgets.statsOverview.production.title',
            values: [
              {
                label: 'widgets.statsOverview.production.self_consumption',
                totalPercentage: 'production_self_consumption_direct_rate',
                id: 'self_consumption_direct',
                progress: [
                  {
                    value: 'production_self_consumption_direct_rate',
                    color: 'self_consumption',
                    className:
                      '_StatsOverview__MultiProgress__Element_15aj1_100',
                  },
                ],
              },
              {
                label: 'widgets.statsOverview.production.to_network',
                totalPercentage: 'production_to_grid_rate',
                id: 'to_grid',
                progress: [
                  {
                    value: 'production_self_consumption_direct_rate',
                    color: '#F0F0F0',
                    className:
                      '_StatsOverview__MultiProgress__Element_15aj1_100',
                  },
                  {
                    value: 'production_to_grid_rate',
                    color: 'production',
                    className:
                      '_StatsOverview__MultiProgress__Element_15aj1_100',
                  },
                ],
              },
            ],
            devID: 'maniacal-lighthouse',
            devPath: 'household->enduser->prosumer->statsOverviewProduction',
          },
          {
            order: 3,
            className: 'px-1 py-0_5 pt-xs-2',
            type: 'card',
            gradientBorder: false,
            subtype: 'sharedEnergyCard',
            id: 'sharedEnergyCard',
            totalValue: 'total_shared',
            icon: 'shared_energy',
            descriptionType: 'description',
            description: 'widgets.sharedEnergyCard.description.prosumer',
            details: {
              type: 'label',
              title: 'widgets.sharedEnergyCard.details.title',
              totalValue: 'total_shared',
              label_1: 'widgets.sharedEnergyCard.details.label',
            },
            devID: 'eccentric-giraffe',
            devPath: 'household->enduser->prosumer->sharedEnergyCard',
          },
          {
            order: 4,
            className: 'px-1 pt-1',

            type: 'card',
            gradientBorder: false,
            subtype: 'savingsCard',
            kpiContext: 'economics',
            id: 'savingsCard',
            totalValue: 'total_benefits',
            icon: 'savings',
            descriptionType: 'label',
            description: 'widgets.savingsCard.description.consumer',
            details: {
              type: 'detailed',
              title: 'widgets.savingsCard.details.consumer.title',
              subtitle: 'widgets.savingsCard.subtitle',
              label_revenues:
                'widgets.savingsCard.details.prosumage.label_revenues',
              label_savings:
                'widgets.savingsCard.details.prosumage.label_savings',
              totalValue: 'total_benefits',
              data: [
                {
                  label: 'widgets.savingsCard.details.consumer.label_1',
                  value: 'public_incentive',
                },
                {
                  label: 'widgets.savingsCard.details.consumer.label_2',
                  value: 'charge_reduction_total',
                },
              ],
            },
            devID: 'golden-penguin',
            devPath: 'household->enduser->prosumer->savingsCard',
          },
          {
            order: 5,
            className: 'px-1 pt-1_5',

            type: 'graphs',
            gradientBorder: false,
            subtype: 'savingsStackbar',
            kpiContext: 'economics',
            id: 'savingsStackbar',
            totalValue: 'total_benefits',
            graphKeys: [
              {
                key: 'revenues',
                color: 'revenues',
                combined: false,
              },
            ],
            colors: ['economics'],
            title: 'widgets.savingsStackbar.title',
            devID: 'silly-buffet',
            devPath: 'household->enduser->prosumer->savingsStackbar',
          },
          {
            order: 6,
            className: 'px-1 pt-1_5',

            type: 'card',
            gradientBorder: false,
            subtype: 'selfSufficiencyCard',
            id: 'selfSufficiencyCard',
            totalValue: 'self_sufficiency_rate',
            icon: 'self_sufficiency',
            descriptionValue: 'self_consumption',
            descriptionType: 'value+label',
            description: 'widgets.selfSufficiencyCard.description.prosumer',
            details: {
              type: 'label+description',
              title: 'widgets.selfSufficiencyCard.details.title',
              totalValue: 'self_sufficiency_rate',
              label: 'widgets.selfSufficiencyCard.details.label',
              description_1:
                'widgets.selfSufficiencyCard.details.description_1',
              value_1: 'self_consumption',
              description_2:
                'widgets.selfSufficiencyCard.details.description_2',
              value_2: 'consumption',
            },
            devID: 'impish-shoe',
            devPath: 'household->enduser->prosumer->selfSufficiencyCard',
          },
          {
            order: 7,
            className: 'px-1 pt-1_5',

            id: 'pollutionCard',
            type: 'card',
            gradientBorder: false,
            kpiContext: 'ancillary',
            subtype: 'pollutionCard',
            totalValue: 'co2_offset_kgs',
            trees: 'co2_offset_trees',
            icon: 'pollution',
            descriptionValue: 'co2_offset_trees',
            descriptionType: '{{trees}}',
            description: {
              line_1: 'widgets.pollutionCard.description.consumer.line_1',
              line_2: 'widgets.pollutionCard.description.consumer.line_2',
            },
            details: {
              type: 'labels+values',
              kpiContext: 'ancillary',
              title: 'widgets.pollutionCard.details.title',
              totalValue: 'co2_offset_kgs',
              data: [
                {
                  label_1: 'widgets.pollutionCard.details.label',
                  value_1: 'widgets.pollutionCard.details.value_1',
                },
                {
                  label_2_1: 'widgets.pollutionCard.details.label_2_1',
                  label_2_2: 'widgets.pollutionCard.details.label_2_2',
                  value_1: 'co2_offset_trees',
                  value_2: 'widgets.pollutionCard.details.value_2',
                },
              ],
            },
            devID: 'jubilant-nacho',
            devPath: 'household->enduser->prosumer->pollutionCard',
          },
          {
            order: 8,
            className: 'px-1 pt-1_5',

            type: 'graphs',
            gradientBorder: false,
            subtype: 'consumptionStackBar',
            id: 'consumptionStackBar',
            totalValue: 'consumption',
            graphKeys: [
              {
                key: 'self_consumption_direct',
                color: 'self_consumption',
                combined: false,
              },
              {
                key: 'from_shared',
                color: 'from_shared',
                combined: true,
                base: false,
              },
              {
                key: 'from_grid',
                color: 'from_grid',
                combined: true,
                base: true,
              },
            ],
            colors: ['self_consumption', 'from_shared', 'from_grid'],
            title: 'widgets.consumptionStackBar.title',
            devID: 'zany-obelisk',
            devPath: 'household->enduser->prosumer->consumptionStackBar',
          },
          {
            order: 9,
            className: 'px-1 pt-1_5',

            type: 'graphs',
            gradientBorder: false,
            subtype: 'productionStackBar',
            id: 'productionStackBar',
            totalValue: 'production',
            graphKeys: [
              {
                key: 'self_consumption_direct',
                color: 'self_consumption',
                combined: false,
              },
              {
                key: 'to_shared',
                color: 'to_shared',
                combined: true,
                base: false,
              },
              {
                key: 'to_grid',
                color: 'to',
                combined: true,
                base: true,
              },
            ],
            colors: ['self_consumption', 'to_shared', 'production'],
            title: 'widgets.productionStackBar.title',
            devID: 'turbulent-lemonade',
            devPath: 'household->enduser->prosumer->productionStackBar',
          },
          {
            order: 10,
            className: 'px-1 pt-1_5',

            type: 'areachart',
            gradientBorder: false,
            subtype: 'areachart',
            id: 'areachart',
            graphKeys: ['consumption', 'production', 'self_consumption'],
            colors: ['consumption', 'production', 'self_consumption'],
            title: 'widgets.areaChart-self-consumption.title',
            devID: 'nocturnal-dragon',
            devPath: 'household->enduser->prosumer->areachart',
          },
        ],
        producer: [
          {
            id: 'consumptionCard',
            keep: false,
            devID: 'wondrous-jellyfish',
            devPath: 'household->enduser->producer->consumptionCard',
          },
          {
            id: 'savingsCard',
            keep: false,
            devID: 'mirthful-yogurt',
            devPath: 'household->enduser->producer->savingsCard',
          },
          {
            id: 'sharedEnergyCard',
            keep: false,
            devID: 'eccentric-giraffe',
            devPath: 'household->enduser->producer->sharedEnergyCard',
          },
          {
            id: 'consumptionStackBar',
            keep: false,
            devID: 'unruly-cabbage',
            devPath: 'household->enduser->producer->consumptionStackBar',
          },
          {
            id: 'pollutionCard',
            keep: false,
            devID: 'eccentric-zeppelin',
            devPath: 'household->enduser->producer->pollutionCard',
          },
          {
            order: 1,
            className: 'px-1 mt-12_5 custom',

            type: 'card',
            gradientBorder: false,
            subtype: 'productionCard',
            id: 'productionCard',
            totalValue: 'production',
            icon: 'production',
            descriptionType: 'label',
            description: 'widgets.productionCard.description.producer',
            detail: false,
            devID: 'peculiar-tangerine',
            devPath: 'household->enduser->producer->productionCard',
          },
          {
            order: 2,
            id: 'savingsCard',
            devID: 'zealous-igloo',
            devPath: 'household->enduser->producer->savingsCard',
          },
          {
            order: 3,
            className: 'px-1 pt-1_5',

            type: 'graphs',
            gradientBorder: false,
            subtype: 'productionStackBar',
            id: 'productionStackBar',
            totalValue: 'production',
            graphKeys: [
              {
                key: 'to_shared',
                color: 'to_shared',
                combined: true,
              },
              {
                key: 'to_grid',
                color: 'to',
                combined: true,
              },
            ],
            combinedKeys: [
              {
                key: 'to_shared',
                color: 'to_shared',
                combined: true,
              },
              {
                key: 'to_grid',
                color: 'to',
                combined: true,
              },
            ],
            colors: ['production', 'self_consumption'],
            title: 'widgets.productionStackBar.title',
            devID: 'rampaging-lollipop',
            devPath: 'household->enduser->producer->productionStackBar',
          },
        ],
        prosumage: [
          {
            id: 'header',
            keep: false,
            devID: 'zesty-cabbage',
            devPath: 'household->enduser->prosumage->header',
          },
          {
            id: 'consumptionCard',
            keep: false,
            devID: 'impish-iceberg',
            devPath: 'household->enduser->prosumage->consumptionCard',
          },
          {
            order: 1,
            className: ' mt-12_5 custom',

            type: 'statsOverview',
            subtype: 'statsOverview',
            id: 'statsOverviewConsumption',
            totalValue: 'consumption',
            color: 'consumption',
            graphDataKeys: [
              {
                key: 'self_consumption_direct',
                label: 'widgets.statsOverview.consumption.self_consumption',
              },
              {
                key: 'self_consumption_battery',
                label:
                  'widgets.statsOverview.consumption.self_consumption_battery',
              },
              {
                key: 'from_grid',
                label: 'widgets.statsOverview.consumption.from_network',
              },
            ],
            graphColors: [
              'self_consumption',
              'self_consumption_battery',
              'consumption',
            ],
            title: 'widgets.statsOverview.consumption.title',
            values: [
              {
                label: 'widgets.statsOverview.consumption.self_consumption',
                totalPercentage: 'consumption_self_consumption_direct_rate',
                id: 'self_consumption_direct',
                progress: [
                  {
                    value: 'consumption_self_consumption_direct_rate',
                    color: 'self_consumption',
                    className:
                      '_StatsOverview__MultiProgress__Element_15aj1_100',
                  },
                ],
              },
              {
                label:
                  'widgets.statsOverview.consumption.self_consumption_battery',
                totalPercentage: 'consumption_self_consumption_battery_rate',
                id: 'self_consumption_battery',
                progress: [
                  {
                    value: 'consumption_self_consumption_direct_rate',
                    color: '#F0F0F0',
                    className:
                      '_StatsOverview__MultiProgress__Element_15aj1_100',
                  },
                  {
                    value: 'consumption_self_consumption_battery_rate',
                    color: 'battery',
                    className:
                      '_StatsOverview__MultiProgress__Element_15aj1_100',
                  },
                ],
              },
              {
                label: 'widgets.statsOverview.consumption.from_network',
                totalPercentage: 'consumption_from_grid_rate',
                id: 'from_grid',
                progress: [
                  {
                    value: 'consumption_self_consumption_direct_rate',
                    color: '#F0F0F0',
                    className:
                      '_StatsOverview__MultiProgress__Element_15aj1_100',
                  },
                  {
                    value: 'consumption_self_consumption_battery_rate',
                    color: '#F0F0F0',
                    className:
                      '_StatsOverview__MultiProgress__Element_15aj1_100',
                  },
                  {
                    value: 'consumption_from_grid_rate',
                    color: 'consumption',
                    className:
                      '_StatsOverview__MultiProgress__Element_15aj1_100',
                  },
                ],
              },
            ],
            devID: 'spritely-lollipop',
            devPath: 'household->enduser->prosumage->statsOverviewConsumption',
          },
          {
            order: 2,
            className: ' pt-1_5',

            type: 'statsOverview',
            subtype: 'statsOverview',
            id: 'statsOverviewProduction',
            totalValue: 'production',
            color: 'production',
            graphDataKeys: [
              {
                key: 'self_consumption_direct',
                label: 'widgets.statsOverview.production.self_consumption',
              },
              {
                key: 'production_to_battery',
                label:
                  'widgets.statsOverview.production.self_consumption_battery',
              },
              {
                key: 'to_grid',
                label: 'widgets.statsOverview.production.from_network',
              },
            ],
            graphColors: ['self_consumption', 'battery', 'production'],
            title: 'widgets.statsOverview.production.title',
            values: [
              {
                label: 'widgets.statsOverview.production.self_consumption',
                totalPercentage: 'production_self_consumption_direct_rate',
                id: 'self_consumption_direct',
                progress: [
                  {
                    value: 'production_self_consumption_direct_rate',
                    color: 'self_consumption',
                    className:
                      '_StatsOverview__MultiProgress__Element_15aj1_100',
                  },
                ],
              },
              {
                label: 'widgets.statsOverview.production.from_battery',
                totalPercentage: 'production_to_battery_rate',
                id: 'production_to_battery',
                progress: [
                  {
                    value: 'production_self_consumption_direct_rate',
                    color: '#F0F0F0',
                    className:
                      '_StatsOverview__MultiProgress__Element_15aj1_100',
                  },
                  {
                    value: 'production_to_battery_rate',
                    color: 'production_to_battery',
                    className:
                      '_StatsOverview__MultiProgress__Element_15aj1_100',
                  },
                ],
              },
              {
                label: 'widgets.statsOverview.production.from_network',
                totalPercentage: 'production_to_grid_rate',
                id: 'to_grid',
                progress: [
                  {
                    value: 'production_self_consumption_direct_rate',
                    color: '#F0F0F0',
                    className:
                      '_StatsOverview__MultiProgress__Element_15aj1_100',
                  },
                  {
                    value: 'production_to_battery_rate',
                    color: '#F0F0F0',
                    className:
                      '_StatsOverview__MultiProgress__Element_15aj1_100',
                  },
                  {
                    value: 'production_to_grid_rate',
                    color: 'production',
                    className:
                      '_StatsOverview__MultiProgress__Element_15aj1_100',
                  },
                ],
              },
            ],
            devID: 'clumsy-buffet',
            devPath: 'household->enduser->prosumage->statsOverviewProduction',
          },
          {
            order: 3,
            className: 'px-1 py-0_5 pt-xs-2',
            type: 'card',
            gradientBorder: false,
            subtype: 'sharedEnergyCard',
            id: 'sharedEnergyCard',
            totalValue: 'total_shared',
            icon: 'shared_energy',
            descriptionType: 'keyValue',
            description: [
              {
                key: 'widgets.sharedEnergyCard.description.prosumage.key_1',
                value: 'from_shared',
              },
              {
                key: 'widgets.sharedEnergyCard.description.prosumage.key_2',
                value: 'to_shared',
              },
            ],
            details: {
              type: 'label',
              title: 'widgets.sharedEnergyCard.details.title',
              totalValue: 'total_shared',
              label_1: 'widgets.sharedEnergyCard.details.label',
              value_1: 'from_shared',
              label_2: 'widgets.sharedEnergyCard.details.label_2',
              value_2: 'to_shared',
            },
            devID: 'rampaging-obelisk',
            devPath: 'household->enduser->prosumage->sharedEnergyCard',
          },
          {
            order: 4,
            className: 'px-1 pt-1_5',

            type: 'card',
            gradientBorder: false,
            subtype: 'savingsCard',
            id: 'savingsCard',
            totalValue: 'total_benefits',
            icon: 'savings',
            kpiContext: 'economics',
            descriptionType: 'label',
            description: 'widgets.savingsCard.description.prosumer',
            details: {
              type: 'detailed',
              title: 'widgets.savingsCard.details.prosumage.title',
              subtitle: 'widgets.savingsCard.subtitle',
              label_revenues:
                'widgets.savingsCard.details.prosumage.label_revenues',
              label_savings:
                'widgets.savingsCard.details.prosumage.label_savings',
              totalValue: 'total_benefits',
              data: [
                {
                  label: 'widgets.savingsCard.details.prosumage.label_1',
                  value: 'direct_compensation',
                },
                {
                  label: 'widgets.savingsCard.details.prosumage.label_2',
                  value: 'public_incentive',
                },
                {
                  label: 'widgets.savingsCard.details.prosumage.label_3',
                  value: 'charge_reduction',
                },
              ],
            },
            devID: 'witty-brick',
            devPath: 'household->enduser->prosumage->savingsCard',
          },
          {
            order: 5,
            className: 'px-1 pt-1_5',

            id: 'savingsStackbar',
            totalValue: 'total_benefits',
            type: 'graphs',
            devID: 'wild-marshmallow',
            devPath: 'household->enduser->prosumage->savingsStackbar',
          },
          {
            order: 6,
            type: 'card',
            gradientBorder: false,
            subtype: 'selfSufficiencyCard',
            id: 'selfSufficiencyCard',
            totalValue: 'self_sufficiency_rate',
            icon: 'self_sufficiency',
            descriptionValue: 'self_consumption',
            descriptionType: 'value+label',
            description: 'widgets.selfSufficiencyCard.description.prosumage',
            details: {
              type: 'label+description',
              title: 'widgets.selfSufficiencyCard.details.title',
              totalValue: 'self_sufficiency_rate',
              label: 'widgets.selfSufficiencyCard.details.label',
              description_1:
                'widgets.selfSufficiencyCard.details.description_1',
              value_1: 'self_consumption',
              description_2:
                'widgets.selfSufficiencyCard.details.description_2',
              value_2: 'consumption',
            },
            devID: 'angry-xylophone',
            devPath: 'household->enduser->prosumage->selfSufficiencyCard',
          },
          {
            order: 7,
            className: 'px-1 pt-1_5',

            id: 'pollutionCard',
            type: 'card',
            gradientBorder: false,
            kpiContext: 'ancillary',
            subtype: 'pollutionCard',
            totalValue: 'co2_offset_kgs',
            trees: 'co2_offset_trees',
            icon: 'pollution',
            descriptionValue: 'co2_offset_trees',
            descriptionType: '{{trees}}',
            description: {
              line_1: 'widgets.pollutionCard.description.consumer.line_1',
              line_2: 'widgets.pollutionCard.description.consumer.line_2',
            },
            details: {
              type: 'labels+values',
              kpiContext: 'ancillary',
              title: 'widgets.pollutionCard.details.title',
              totalValue: 'co2_offset_kgs',
              data: [
                {
                  label_1: 'widgets.pollutionCard.details.label',
                  value_1: 'widgets.pollutionCard.details.value_1',
                },
                {
                  label_2_1: 'widgets.pollutionCard.details.label_2_1',
                  label_2_2: 'widgets.pollutionCard.details.label_2_2',
                  value_1: 'co2_offset_trees',
                  value_2: 'widgets.pollutionCard.details.value_2',
                },
              ],
            },
            devID: 'kooky-marshmallow',
            devPath: 'household->enduser->prosumage->pollutionCard',
          },
          {
            order: 8,
            className: 'px-1 pt-1_5',

            type: 'graphs',
            gradientBorder: false,
            subtype: 'consumptionStackBar',
            id: 'consumptionStackBar',
            totalValue: 'consumption',
            graphKeys: [
              {
                key: 'self_consumption_direct',
                color: 'self_consumption',
                combined: false,
              },
              {
                key: 'self_consumption_battery',
                color: 'battery',
                combined: false,
              },
              {
                key: 'from_shared',
                color: 'from_shared',
                combined: true,
                base: false,
              },
              {
                key: 'from_grid',
                color: 'from_grid',
                combined: true,
                base: true,
              },
            ],
            colors: ['self_consumption', 'battery', 'consumption'],
            title: 'widgets.consumptionStackBar.title',
            devID: 'turbulent-avocado',
            devPath: 'household->enduser->prosumage->consumptionStackBar',
          },
          {
            order: 9,
            className: 'px-1 pt-1_5',

            type: 'graphs',
            gradientBorder: false,
            subtype: 'productionStackBar',
            id: 'productionStackBar',
            totalValue: 'production',
            graphKeys: [
              {
                key: 'self_consumption_direct',
                color: 'self_consumption',
                combined: false,
              },
              {
                key: 'production_to_battery',
                color: 'battery',
                combined: false,
              },
              {
                key: 'to_shared',
                color: 'to_shared',
                combined: true,
                base: false,
              },
              {
                key: 'to_grid',
                color: 'to',
                combined: true,
                base: true,
              },
            ],
            colors: ['self_consumption', 'battery', 'production'],
            title: 'widgets.productionStackBar.title',
            devID: 'kooky-vortex',
            devPath: 'household->enduser->prosumage->productionStackBar',
          },
          {
            id: 'batteryChartMobile',
            title: 'widgets.batteryChart.title',
            type: 'graphs',
            subtype: 'batteryChartMobile',
            gradientBorder: false,
            context: 'site',
            buttons: [
              'widgets.batteryChart.self_consumption_battery',
              'widgets.batteryChart.production_to_battery',
              'widgets.batteryChart.soc',
            ],
            colors: [
              {
                color: 'self_consumption_battery',
                colorShade: '',
              },
              {
                color: 'production_to_battery',
                colorShade: '',
              },
              {
                color: 'soc_battery',
                colorShade: '',
              },
            ],
            db_fields: [
              'self_consumption_battery',
              'production_to_battery',
              'soc_battery',
            ],
            devID: 'witty-rhinoceros',
            devPath: 'household->enduser->prosumage->batteryChartMobile',
          },
          {
            type: 'areachart',
            gradientBorder: false,
            subtype: 'areachart',
            id: 'areachart',
            graphKeys: ['consumption', 'production', 'self_consumption'],
            colors: ['consumption', 'production', 'self_consumption'],
            title: 'widgets.areaChart-self-consumption.title',
            devID: 'rambunctious-hedgehog',
            devPath: 'household->enduser->prosumage->areachart',
          },
          {
            type: 'footer',
            subtype: 'footer',
            id: 'footer',
            sections: ['household', 'community'],
            devID: 'playful-banana',
            devPath: 'household->enduser->prosumage->footer',
          },
        ],
      },
      'org:supervisor': {
        consumer: [],
        prosumer: [
          {
            id: 'consumptionCard',
            keep: false,
            devID: 'zealous-butterfly',
            devPath: 'household->org:supervisor->prosumer->consumptionCard',
          },
          {
            order: 1,
            className: ' mt-12_5 custom',

            type: 'statsOverview',
            subtype: 'statsOverview',
            id: 'statsOverviewConsumption',
            totalValue: 'consumption',
            color: 'consumption',
            graphDataKeys: [
              {
                key: 'from_grid',
                label: 'widgets.statsOverview.consumption.from_network',
              },
              {
                key: 'self_consumption_direct',
                label: 'widgets.statsOverview.consumption.self_consumption',
              },
            ],
            graphColors: ['consumption', 'self_consumption'],
            title: 'widgets.statsOverview.consumption.title',
            values: [
              {
                label: 'widgets.statsOverview.consumption.self_consumption',
                totalPercentage: 'consumption_self_consumption_direct_rate',
                id: 'self_consumption_direct',
                progress: [
                  {
                    value: 'consumption_self_consumption_direct_rate',
                    color: 'self_consumption',
                    className:
                      '_StatsOverview__MultiProgress__Element_15aj1_100',
                  },
                ],
              },
              {
                label: 'widgets.statsOverview.consumption.from_network',
                totalPercentage: 'consumption_from_grid_rate',
                id: 'from_grid',
                progress: [
                  {
                    value: 'consumption_self_consumption_direct_rate',
                    color: '#F0F0F0',
                    className:
                      '_StatsOverview__MultiProgress__Element_15aj1_100',
                  },
                  {
                    value: 'consumption_from_grid_rate',
                    color: 'consumption',
                    className:
                      '_StatsOverview__MultiProgress__Element_15aj1_100',
                  },
                ],
              },
            ],
            devID: 'unruly-giraffe',
            devPath:
              'household->org:supervisor->prosumer->statsOverviewConsumption',
          },
          {
            order: 2,
            className: ' pt-1_5',

            type: 'statsOverview',
            subtype: 'statsOverview',
            id: 'statsOverviewProduction',
            totalValue: 'production',
            color: 'production',
            graphDataKeys: [
              {
                key: 'self_consumption_direct',
                label: 'widgets.statsOverview.production.self_consumption',
              },
              {
                key: 'to_grid',
                label: 'widgets.statsOverview.production.to_network',
              },
            ],
            graphColors: ['self_consumption', 'production'],
            title: 'widgets.statsOverview.production.title',
            values: [
              {
                label: 'widgets.statsOverview.production.self_consumption',
                totalPercentage: 'production_self_consumption_direct_rate',
                id: 'self_consumption_direct',
                progress: [
                  {
                    value: 'production_self_consumption_direct_rate',
                    color: 'self_consumption',
                    className:
                      '_StatsOverview__MultiProgress__Element_15aj1_100',
                  },
                ],
              },
              {
                label: 'widgets.statsOverview.production.to_network',
                totalPercentage: 'production_to_grid_rate',
                id: 'to_grid',
                progress: [
                  {
                    value: 'production_self_consumption_direct_rate',
                    color: '#F0F0F0',
                    className:
                      '_StatsOverview__MultiProgress__Element_15aj1_100',
                  },
                  {
                    value: 'production_to_grid_rate',
                    color: 'production',
                    className:
                      '_StatsOverview__MultiProgress__Element_15aj1_100',
                  },
                ],
              },
            ],
            devID: 'whimsical-kangaroo',
            devPath:
              'household->org:supervisor->prosumer->statsOverviewProduction',
          },
          {
            order: 3,
            className: 'px-1 py-0_5 pt-xs-2',
            type: 'card',
            gradientBorder: false,
            subtype: 'sharedEnergyCard',
            id: 'sharedEnergyCard',
            totalValue: 'total_shared',
            icon: 'shared_energy',
            descriptionType: 'keyValue',
            description: [
              {
                key: 'widgets.sharedEnergyCard.description.prosumer.key_1',
                value: 'from_shared',
              },
              {
                key: 'widgets.sharedEnergyCard.description.prosumer.key_2',
                value: 'to_shared',
              },
            ],
            details: {
              type: 'label',
              title: 'widgets.sharedEnergyCard.details.title',
              totalValue: 'total_shared',
              label_1: 'widgets.sharedEnergyCard.details.label',
              value_1: 'from_shared',
              label_2: 'widgets.sharedEnergyCard.details.label_2',
              value_2: 'to_shared',
            },
            devID: 'jazzy-espresso',
            devPath: 'household->org:supervisor->prosumer->sharedEnergyCard',
          },
          {
            order: 4,
            className: 'px-1 pt-1',

            type: 'card',
            gradientBorder: false,
            subtype: 'savingsCard',
            kpiContext: 'economics',
            id: 'savingsCard',
            totalValue: 'total_benefits',
            icon: 'savings',
            descriptionType: 'label',
            description: 'widgets.savingsCard.description.consumer',
            details: {
              type: 'detailed',
              subtitle: 'widgets.savingsCard.subtitle',
              label_revenues:
                'widgets.savingsCard.details.consumer.label_revenues',
              label_savings:
                'widgets.savingsCard.details.consumer.label_savings',
              totalValue: 'total_benefits',
              label: 'widgets.savingsCard.details.consumer.label',
              data: [
                {
                  label: 'widgets.savingsCard.details.consumer.label_1',
                  value: 'public_incentive',
                },
                {
                  label: 'widgets.savingsCard.details.consumer.label_2',
                  value: 'charge_reduction_total',
                },
              ],
            },
            devID: 'happy-flamingo',
            devPath: 'household->org:supervisor->prosumer->savingsCard',
          },
          {
            order: 5,
            className: 'px-1 pt-1_5',

            type: 'graphs',
            gradientBorder: false,
            subtype: 'savingsStackbar',
            kpiContext: 'economics',
            id: 'savingsStackbar',
            totalValue: 'total_benefits',
            graphKeys: [
              {
                key: 'revenues',
                color: 'revenues',
                combined: false,
              },
            ],
            colors: ['economics'],
            title: 'widgets.savingsStackbar.title',
            devID: 'boisterous-dinosaur',
            devPath: 'household->org:supervisor->prosumer->savingsStackbar',
          },
          {
            order: 6,
            className: 'px-1 pt-1_5',

            type: 'card',
            gradientBorder: false,
            subtype: 'selfSufficiencyCard',
            id: 'selfSufficiencyCard',
            totalValue: 'self_sufficiency_rate',
            icon: 'self_sufficiency',
            descriptionValue: 'self_consumption',
            descriptionType: 'value+label',
            description: 'widgets.selfSufficiencyCard.description.prosumer',
            details: {
              type: 'label+description',
              title: 'widgets.selfSufficiencyCard.details.title',
              totalValue: 'self_sufficiency_rate',
              label: 'widgets.selfSufficiencyCard.details.label',
              description_1:
                'widgets.selfSufficiencyCard.details.description_1',
              value_1: 'self_consumption',
              description_2:
                'widgets.selfSufficiencyCard.details.description_2',
              value_2: 'consumption',
            },
            devID: 'rowdy-pencil',
            devPath: 'household->org:supervisor->prosumer->selfSufficiencyCard',
          },
          {
            order: 7,
            className: 'px-1 pt-1_5',

            id: 'pollutionCard',
            type: 'card',
            gradientBorder: false,
            kpiContext: 'ancillary',
            subtype: 'pollutionCard',
            totalValue: 'co2_offset_kgs',
            trees: 'co2_offset_trees',
            icon: 'pollution',
            descriptionValue: 'co2_offset_trees',
            descriptionType: '{{trees}}',
            description: {
              line_1: 'widgets.pollutionCard.description.consumer.line_1',
              line_2: 'widgets.pollutionCard.description.consumer.line_2',
            },
            details: {
              type: 'labels+values',
              kpiContext: 'ancillary',
              title: 'widgets.pollutionCard.details.title',
              totalValue: 'co2_offset_kgs',
              data: [
                {
                  label_1: 'widgets.pollutionCard.details.label',
                  value_1: 'widgets.pollutionCard.details.value_1',
                },
                {
                  label_2_1: 'widgets.pollutionCard.details.label_2_1',
                  label_2_2: 'widgets.pollutionCard.details.label_2_2',
                  value_1: 'co2_offset_trees',
                  value_2: 'widgets.pollutionCard.details.value_2',
                },
              ],
            },
            devID: 'turbulent-lighthouse',
            devPath: 'household->org:supervisor->prosumer->pollutionCard',
          },
          {
            order: 8,
            className: 'px-1 pt-1_5',

            type: 'graphs',
            gradientBorder: false,
            subtype: 'consumptionStackBar',
            id: 'consumptionStackBar',
            totalValue: 'consumption',
            graphKeys: [
              {
                key: 'self_consumption_direct',
                color: 'self_consumption',
                combined: false,
              },
              {
                key: 'from_shared',
                color: 'from_shared',
                combined: true,
              },
              {
                key: 'from_grid',
                color: 'from_grid',
                combined: true,
              },
            ],
            combinedKeys: [
              {
                key: 'from_shared',
                color: 'from_shared',
                combined: true,
              },
              {
                key: 'from_grid',
                color: 'from_grid',
                combined: true,
              },
            ],
            colors: ['self_consumption', 'from_shared', 'from_grid'],
            title: 'widgets.consumptionStackBar.title',
            devID: 'giddy-gumball',
            devPath: 'household->org:supervisor->prosumer->consumptionStackBar',
          },
          {
            order: 9,
            className: 'px-1 pt-1_5',

            type: 'graphs',
            gradientBorder: false,
            subtype: 'productionStackBar',
            id: 'productionStackBar',
            totalValue: 'production',
            graphKeys: [
              {
                key: 'self_consumption_direct',
                color: 'self_consumption',
                combined: false,
              },
              {
                key: 'to_shared',
                color: 'to_shared',
                combined: true,
              },
              {
                key: 'to_grid',
                color: 'to',
                combined: true,
              },
            ],
            combinedKeys: [
              {
                key: 'to_shared',
                color: 'to_shared',
                combined: true,
              },
              {
                key: 'to_grid',
                color: 'to',
                combined: true,
              },
            ],
            colors: ['self_consumption', 'to_shared', 'production'],
            title: 'widgets.productionStackBar.title',
            devID: 'quirky-flamingo',
            devPath: 'household->org:supervisor->prosumer->productionStackBar',
          },
          {
            order: 10,
            className: 'px-1 pt-1_5',

            type: 'areachart',
            gradientBorder: false,
            subtype: 'areachart',
            id: 'areachart',
            graphKeys: ['consumption', 'production', 'self_consumption'],
            colors: ['consumption', 'production', 'self_consumption'],
            title: 'widgets.areaChart-self-consumption.title',
            devID: 'mirthful-marshmallow',
            devPath: 'household->org:supervisor->prosumer->areachart',
          },
        ],
        producer: [
          {
            id: 'consumptionCard',
            keep: false,
            devID: 'waggish-zeppelin',
            devPath: 'household->org:supervisor->producer->consumptionCard',
          },
          {
            id: 'savingsCard',
            keep: false,
            devID: 'ferocious-pajamas',
            devPath: 'household->org:supervisor->producer->savingsCard',
          },
          {
            id: 'sharedEnergyCard',
            keep: false,
            devID: 'quirky-pajamas',
            devPath: 'household->org:supervisor->producer->sharedEnergyCard',
          },
          {
            id: 'consumptionStackBar',
            keep: false,
            devID: 'ludicrous-dragon',
            devPath: 'household->org:supervisor->producer->consumptionStackBar',
          },
          {
            id: 'pollutionCard',
            keep: false,
            devID: 'whimsical-waffle',
            devPath: 'household->org:supervisor->producer->pollutionCard',
          },
          {
            order: 1,
            className: 'px-1 mt-12_5 custom',

            type: 'card',
            gradientBorder: false,
            subtype: 'productionCard',
            id: 'productionCard',
            totalValue: 'production',
            icon: 'production',
            descriptionType: 'label',
            description: 'widgets.productionCard.description.producer',
            detail: false,
            devID: 'rowdy-firecracker',
            devPath: 'household->org:supervisor->producer->productionCard',
          },
          {
            order: 2,
            id: 'savingsCard',
            devID: 'rampaging-mango',
            devPath: 'household->org:supervisor->producer->savingsCard',
          },
          {
            order: 3,
            className: 'px-1 pt-1_5',

            type: 'graphs',
            gradientBorder: false,
            subtype: 'productionStackBar',
            id: 'productionStackBar',
            totalValue: 'production',
            graphKeys: [
              {
                key: 'to_shared',
                color: 'to_shared',
                combined: true,
              },
              {
                key: 'to_grid',
                color: 'to',
                combined: true,
              },
            ],
            combinedKeys: [
              {
                key: 'to_shared',
                color: 'to_shared',
                combined: true,
              },
              {
                key: 'to_grid',
                color: 'to',
                combined: true,
              },
            ],
            colors: ['production', 'self_consumption'],
            title: 'widgets.productionStackBar.title',
            devID: 'whacky-buffet',
            devPath: 'household->org:supervisor->producer->productionStackBar',
          },
        ],
        prosumage: [
          {
            id: 'header',
            keep: false,
            devID: 'ferocious-vortex',
            devPath: 'household->org:supervisor->prosumage->header',
          },
          {
            id: 'consumptionCard',
            keep: false,
            devID: 'clumsy-quokka',
            devPath: 'household->org:supervisor->prosumage->consumptionCard',
          },
          {
            order: 1,
            className: ' mt-12_5 custom',

            type: 'statsOverview',
            subtype: 'statsOverview',
            id: 'statsOverviewConsumption',
            totalValue: 'consumption',
            color: 'consumption',
            graphDataKeys: [
              {
                key: 'self_consumption_direct',
                label: 'widgets.statsOverview.consumption.self_consumption',
              },
              {
                key: 'self_consumption_battery',
                label:
                  'widgets.statsOverview.consumption.self_consumption_battery',
              },
              {
                key: 'from_grid',
                label: 'widgets.statsOverview.consumption.from_network',
              },
            ],
            graphColors: [
              'self_consumption',
              'self_consumption_battery',
              'consumption',
            ],
            title: 'widgets.statsOverview.consumption.title',
            values: [
              {
                label: 'widgets.statsOverview.consumption.self_consumption',
                totalPercentage: 'consumption_self_consumption_direct_rate',
                id: 'self_consumption_direct',
                progress: [
                  {
                    value: 'consumption_self_consumption_direct_rate',
                    color: 'self_consumption',
                    className:
                      '_StatsOverview__MultiProgress__Element_15aj1_100',
                  },
                ],
              },
              {
                label:
                  'widgets.statsOverview.consumption.self_consumption_battery',
                totalPercentage: 'consumption_self_consumption_battery_rate',
                id: 'self_consumption_battery',
                progress: [
                  {
                    value: 'consumption_self_consumption_direct_rate',
                    color: '#F0F0F0',
                    className:
                      '_StatsOverview__MultiProgress__Element_15aj1_100',
                  },
                  {
                    value: 'consumption_self_consumption_battery_rate',
                    color: 'battery',
                    className:
                      '_StatsOverview__MultiProgress__Element_15aj1_100',
                  },
                ],
              },
              {
                label: 'widgets.statsOverview.consumption.from_network',
                totalPercentage: 'consumption_from_grid_rate',
                id: 'from_grid',
                progress: [
                  {
                    value: 'consumption_self_consumption_direct_rate',
                    color: '#F0F0F0',
                    className:
                      '_StatsOverview__MultiProgress__Element_15aj1_100',
                  },
                  {
                    value: 'consumption_self_consumption_battery_rate',
                    color: '#F0F0F0',
                    className:
                      '_StatsOverview__MultiProgress__Element_15aj1_100',
                  },
                  {
                    value: 'consumption_from_grid_rate',
                    color: 'consumption',
                    className:
                      '_StatsOverview__MultiProgress__Element_15aj1_100',
                  },
                ],
              },
            ],
            devID: 'rowdy-cabbage',
            devPath:
              'household->org:supervisor->prosumage->statsOverviewConsumption',
          },
          {
            order: 2,
            className: 'pt-1_5',

            type: 'statsOverview',
            subtype: 'statsOverview',
            id: 'statsOverviewProduction',
            totalValue: 'production',
            color: 'production',
            graphDataKeys: [
              {
                key: 'self_consumption_direct',
                label: 'widgets.statsOverview.production.self_consumption',
              },
              {
                key: 'production_to_battery',
                label:
                  'widgets.statsOverview.production.self_consumption_battery',
              },
              {
                key: 'to_grid',
                label: 'widgets.statsOverview.production.from_network',
              },
            ],
            graphColors: ['self_consumption', 'battery', 'production'],
            title: 'widgets.statsOverview.production.title',
            values: [
              {
                label: 'widgets.statsOverview.production.self_consumption',
                totalPercentage: 'production_self_consumption_direct_rate',
                id: 'self_consumption_direct',
                progress: [
                  {
                    value: 'production_self_consumption_direct_rate',
                    color: 'self_consumption',
                    className:
                      '_StatsOverview__MultiProgress__Element_15aj1_100',
                  },
                ],
              },
              {
                label: 'widgets.statsOverview.production.from_battery',
                totalPercentage: 'production_to_battery_rate',
                id: 'production_to_battery',
                progress: [
                  {
                    value: 'production_self_consumption_direct_rate',
                    color: '#F0F0F0',
                    className:
                      '_StatsOverview__MultiProgress__Element_15aj1_100',
                  },
                  {
                    value: 'production_to_battery_rate',
                    color: 'production_to_battery',
                    className:
                      '_StatsOverview__MultiProgress__Element_15aj1_100',
                  },
                ],
              },
              {
                label: 'widgets.statsOverview.production.from_network',
                totalPercentage: 'production_to_grid_rate',
                id: 'to_grid',
                progress: [
                  {
                    value: 'production_self_consumption_direct_rate',
                    color: '#F0F0F0',
                    className:
                      '_StatsOverview__MultiProgress__Element_15aj1_100',
                  },
                  {
                    value: 'production_to_battery_rate',
                    color: '#F0F0F0',
                    className:
                      '_StatsOverview__MultiProgress__Element_15aj1_100',
                  },
                  {
                    value: 'production_to_grid_rate',
                    color: 'production',
                    className:
                      '_StatsOverview__MultiProgress__Element_15aj1_100',
                  },
                ],
              },
            ],
            devID: 'rowdy-mango',
            devPath:
              'household->org:supervisor->prosumage->statsOverviewProduction',
          },
          {
            order: 3,
            className: 'px-1 py-0_5 pt-xs-2',
            type: 'card',
            gradientBorder: false,
            subtype: 'sharedEnergyCard',
            id: 'sharedEnergyCard',
            totalValue: 'total_shared',
            icon: 'shared_energy',
            descriptionType: 'keyValue',
            description: [
              {
                key: 'widgets.sharedEnergyCard.description.prosumage.key_1',
                value: 'from_shared',
              },
              {
                key: 'widgets.sharedEnergyCard.description.prosumage.key_2',
                value: 'to_shared',
              },
            ],
            details: {
              type: 'label',
              title: 'widgets.sharedEnergyCard.details.title',
              totalValue: 'total_shared',
              label_1: 'widgets.sharedEnergyCard.details.label',
              value_1: 'from_shared',
              label_2: 'widgets.sharedEnergyCard.details.label_2',
              value_2: 'to_shared',
            },
            devID: 'hysterical-cabbage',
            devPath: 'household->org:supervisor->prosumage->sharedEnergyCard',
          },
          {
            order: 4,
            className: 'px-1 pt-1',

            type: 'card',
            gradientBorder: false,
            subtype: 'savingsCard',
            kpiContext: 'economics',
            id: 'savingsCard',
            totalValue: 'total_benefits',
            icon: 'savings',
            descriptionType: 'label',
            description: 'widgets.savingsCard.description.prosumer',
            details: {
              type: 'detailed',
              title: 'widgets.savingsCard.details.prosumage.title',
              totalValue: 'total_benefits',
              subtitle: 'widgets.savingsCard.subtitle',
              label_revenues:
                'widgets.savingsCard.details.prosumage.label_revenues',
              label_savings:
                'widgets.savingsCard.details.prosumage.label_savings',
              data: [
                {
                  label: 'widgets.savingsCard.details.prosumage.label_1',
                  value: 'direct_compensation',
                },
                {
                  label: 'widgets.savingsCard.details.prosumage.label_2',
                  value: 'public_incentive',
                },
                {
                  label: 'widgets.savingsCard.details.prosumage.label_3',
                  value: 'charge_reduction',
                },
              ],
            },
            devID: 'whimsical-giraffe',
            devPath: 'household->org:supervisor->prosumage->savingsCard',
          },
          {
            order: 5,
            className: 'px-1 pt-1_5',

            id: 'savingsStackbar',
            totalValue: 'total_benefits',
            type: 'graphs',
            devID: 'eccentric-glove',
            devPath: 'household->org:supervisor->prosumage->savingsStackbar',
          },
          {
            order: 6,
            type: 'card',
            gradientBorder: false,
            subtype: 'selfSufficiencyCard',
            id: 'selfSufficiencyCard',
            totalValue: 'self_sufficiency_rate',
            icon: 'self_sufficiency',
            descriptionValue: 'self_consumption',
            descriptionType: 'value+label',
            description: 'widgets.selfSufficiencyCard.description.prosumage',
            details: {
              type: 'label+description',
              title: 'widgets.selfSufficiencyCard.details.title',
              totalValue: 'self_sufficiency_rate',
              label: 'widgets.selfSufficiencyCard.details.label',
              description_1:
                'widgets.selfSufficiencyCard.details.description_1',
              value_1: 'self_consumption',
              description_2:
                'widgets.selfSufficiencyCard.details.description_2',
              value_2: 'consumption',
            },
            devID: 'frisky-buffet',
            devPath:
              'household->org:supervisor->prosumage->selfSufficiencyCard',
          },
          {
            order: 7,
            className: 'px-1 pt-1_5',

            id: 'pollutionCard',
            type: 'card',
            gradientBorder: false,
            kpiContext: 'ancillary',
            subtype: 'pollutionCard',
            totalValue: 'co2_offset_kgs',
            trees: 'co2_offset_trees',
            icon: 'pollution',
            descriptionValue: 'co2_offset_trees',
            descriptionType: '{{trees}}',
            description: {
              line_1: 'widgets.pollutionCard.description.consumer.line_1',
              line_2: 'widgets.pollutionCard.description.consumer.line_2',
            },
            details: {
              type: 'labels+values',
              kpiContext: 'ancillary',
              title: 'widgets.pollutionCard.details.title',
              totalValue: 'co2_offset_kgs',
              data: [
                {
                  label_1: 'widgets.pollutionCard.details.label',
                  value_1: 'widgets.pollutionCard.details.value_1',
                },
                {
                  label_2_1: 'widgets.pollutionCard.details.label_2_1',
                  label_2_2: 'widgets.pollutionCard.details.label_2_2',
                  value_1: 'co2_offset_trees',
                  value_2: 'widgets.pollutionCard.details.value_2',
                },
              ],
            },
            devID: 'nocturnal-espresso',
            devPath: 'household->org:supervisor->prosumage->pollutionCard',
          },
          {
            order: 8,
            className: 'px-1 pt-1_5',

            type: 'graphs',
            gradientBorder: false,
            subtype: 'consumptionStackBar',
            id: 'consumptionStackBar',
            totalValue: 'consumption',
            graphKeys: [
              {
                key: 'self_consumption_direct',
                color: 'self_consumption',
                combined: false,
              },
              {
                key: 'self_consumption_battery',
                color: 'battery',
                combined: false,
              },
              {
                key: 'from_shared',
                color: 'from_shared',
                combined: true,
              },
              {
                key: 'from_grid',
                color: 'from_grid',
                combined: true,
              },
            ],
            combinedKeys: [
              {
                key: 'from_shared',
                color: 'from_shared',
                combined: true,
              },
              {
                key: 'from_grid',
                color: 'from_grid',
                combined: true,
              },
            ],
            colors: ['self_consumption', 'battery', 'consumption'],
            title: 'widgets.consumptionStackBar.title',
            devID: 'bizarre-hedgehog',
            devPath:
              'household->org:supervisor->prosumage->consumptionStackBar',
          },
          {
            order: 9,
            className: 'px-1 pt-1_5',

            type: 'graphs',
            gradientBorder: false,
            subtype: 'productionStackBar',
            id: 'productionStackBar',
            totalValue: 'production',
            graphKeys: [
              {
                key: 'self_consumption_direct',
                color: 'self_consumption',
                combined: false,
              },
              {
                key: 'production_to_battery',
                color: 'battery',
                combined: false,
              },
              {
                key: 'to_shared',
                color: 'to_shared',
                combined: true,
              },
              {
                key: 'to_grid',
                color: 'to',
                combined: true,
              },
            ],
            combinedKeys: [
              {
                key: 'to_shared',
                color: 'to_shared',
                combined: true,
              },
              {
                key: 'to_grid',
                color: 'to',
                combined: true,
              },
            ],
            colors: ['self_consumption', 'battery', 'production'],
            title: 'widgets.productionStackBar.title',
            devID: 'fantastic-saxophone',
            devPath: 'household->org:supervisor->prosumage->productionStackBar',
          },
        ],
      },
    },
  },
  {
    name: 'community',

    active: {
      default: true,
    },
    visible: {
      default: false,
    },
    footer: {
      default: false,
    },
    header: {
      default: false,
    },
    datePicker: {
      default: false,
    },
    pullToRefresh: {
      default: false,
    },
    needsAuth: true,
    needsID: true,
    apis: {
      default: [
        'AppConfigResolver',
        'EntitiesResolver',
        'CommunityResolver',
        'EnergyKpiCommunityResolver',
        'AncillaryKpiCommunityResolver',
        'EconomicsKpiCommunityResolver',
        'ComparisonKpiCommunityResolver',
        'EnergyCustomKpiCommunityResolver',
        'EconomicsCustomKpiCommunityResolver',
      ],
    },
    widgets: {
      default: [
        {
          order: 0,
          type: 'header',
          id: 'header',
          widgetName: 'header enduser producer',
          calendarColor: 'white',
          profileSections: [
            {
              key: 'ACCOUNT',
              icon: 'account',
              label: 'pages.profile.account.title',
              backgroundColor: '#ffffff',
              content: {
                title: 'pages.profile.account.title',
                subtitle: 'pages.profile.account.subtitle',
                backgroundColor: '#f7f7f7',
                containedLabelTextfield: false,
                textfields: [
                  {
                    label: 'pages.profile.account.name',
                    value: 'name',
                    type: 'text',
                    containedLabelTextfield: false,
                    textfieldColor: 'white',
                    placeholder: 'pages.profile.account.name_placeholder',
                  },
                  {
                    label: 'pages.profile.account.email',
                    value: 'email',
                    type: 'text',
                    containedLabelTextfield: false,
                    textfieldColor: 'white',
                    placeholder: 'pages.profile.account.email_placeholder',
                  },
                  {
                    label: 'pages.profile.account.password',
                    value: 'password',
                    type: 'password',
                    containedLabelTextfield: false,
                    textfieldColor: 'white',
                    placeholder: 'pages.profile.account.password_placeholder',
                  },
                  {
                    label: 'pages.profile.account.confirm_password',
                    value: 'confirmPassword',
                    type: 'password',
                    containedLabelTextfield: false,
                    textfieldColor: 'white',
                    placeholder:
                      'pages.profile.account.confirm_password_placeholder',
                  },
                ],
                confirmButton: 'pages.profile.account.confirm',
                deleteButton: 'pages.profile.account.delete',
              },
            },
            {
              key: 'BILLING',
              icon: 'bill_solid',
              label: 'pages.profile.billing.title',
              backgroundColor: '#ffffff',
              content: {
                title: 'pages.profile.billing.title',
                subtitle: 'pages.profile.billing.subtitle',
                backgroundColor: '#f7f7f7',
                // view: 'site',
                // selectedSites: [], // This should be populated with actual selected sites from state
              },
            },
            {
              key: 'FEEDBACK',
              icon: 'feedback_star',
              label: 'pages.profile.feedback.title',
              backgroundColor: '#ffffff',
              content: {
                title: 'pages.profile.feedback.title',
                subtitle: 'pages.profile.feedback.subtitle',
                backgroundColor: '#f7f7f7',
                label_1: 'pages.profile.feedback.label_1',
                label_2: 'pages.profile.feedback.label_2',
                label_3: 'pages.profile.feedback.label_3',
                terms: 'pages.profile.feedback.terms',
                comment_label: 'pages.profile.feedback.comment_label',
                confirmButton: 'pages.profile.feedback.confirmButton',
                buttonDescription: 'pages.profile.feedback.button_description',
                confirmationTitle: 'pages.profile.feedback.confirmation_title',
                confirmationDescription:
                  'pages.profile.feedback.confirmationDescription',
                thankYou: 'pages.profile.feedback.thankYou',
                doneButton: 'pages.profile.feedback.doneButton',
              },
            },
            {
              key: 'ABOUT',
              icon: 'legal',
              label: 'pages.profile.about.title',
              backgroundColor: '#ffffff',
              content: {
                title: 'pages.profile.about.title',
                subtitle: 'pages.profile.about.subtitle',
                backgroundColor: '#f7f7f7',
                dataProtection: 'pages.profile.about.data_protection',
                terms: 'pages.profile.about.terms',
                sections: [
                  'pages.profile.about.section_1',
                  'pages.profile.about.section_2',
                ],
              },
            },
          ],
          devID: 'rowdy-generala',
          devPath: 'household->default->header',
        },
        {
          order: 1,
          className: 'px-1 customMargin',
          type: 'communityStats',
          id: 'communityStats',
          gradientBorder: false,
          data: [
            {
              title: 'consumption',
              totalAmount: 'community_consumption_total',
              color: 'consumption',
              percentage: 'site_consumption_contribution_rate',
              graphData: [
                {
                  id: 'consumption',
                  label: 'community',
                  value: 'community_consumption_remainder',
                  formattedValue: 'community_consumption_remainder_rate',
                  color: 'consumption',
                  colorShade: '60',
                },
                {
                  id: 'consumption',
                  label: 'sites',
                  value: 'member_import_contribution',
                  formattedValue: 'member_import_contribution',
                  color: 'consumption',
                  colorShade: '90',
                },
              ],
            },
            {
              title: 'production',
              totalAmount: 'community_production_total',
              color: 'production',
              percentage: 'site_production_contribution_rate',
              graphData: [
                {
                  id: 'production',
                  label: 'community',
                  value: 'community_production_remainder',
                  formattedValue: 'community_production_remainder_rate',
                  color: 'production',
                  colorShade: '60',
                },
                {
                  id: 'production',
                  label: 'sites',
                  value: 'site_production_contribution',
                  formattedValue: 'site_production_contribution_rate',
                  color: 'production',
                  colorShade: '90',
                },
              ],
            },
            {
              title: 'shared',
              totalAmount: 'community_shared_total',
              color: 'total_shared',
              percentage: 'site_shared_contribution_rate',
              graphData: [
                {
                  id: 'shared',
                  label: 'community',
                  value: 'community_shared_remainder',
                  formattedValue: 'community_shared_remainder_rate',
                  color: 'total_shared',
                  colorShade: '60',
                },
                {
                  id: 'shared',
                  label: 'sites',
                  value: 'site_shared_consumption',
                  formattedValue: 'site_shared_contribution_rate',
                  color: 'total_shared',
                  colorShade: '90',
                },
              ],
            },
          ],
          devID: 'nocturnal-thick',
          devPath: 'community->default->communityStats',
        },
        {
          order: 3,
          className: 'px-1 pt-1_5',

          type: 'card',
          gradientBorder: false,
          kpiContext: 'ancillary',
          subtype: 'pollutionCardCommunity',
          id: 'pollutionCardCommunity',
          totalValue: 'co2_offset_kgs',
          trees: 'co2_offset_trees',
          icon: 'pollution',
          descriptionValue: 'co2_offset_trees',
          descriptionType: '{{trees}}',
          description: {
            line_1: 'widgets.pollutionCardCommunity.description.line_1',
            line_2: 'widgets.pollutionCardCommunity.description.line_2',
          },
          details: {
            type: 'labels+values',
            kpiContext: 'ancillary',
            title: 'widgets.pollutionCard.details.title',
            totalValue: 'co2_offset_kgs',
            data: [
              {
                label_1: 'widgets.pollutionCard.details.label',
                value_1: '0,45857 kg CO2 x kWh',
              },
              {
                label_2_1: 'widgets.pollutionCard.details.label_2_1',
                label_2_2: 'widgets.pollutionCard.details.label_2_2',
                value_1: 'co2_offset_trees',
                value_2: 'CO2 / 25',
              },
            ],
          },
          devID: 'kooky-lighthouse',
          devPath: 'community->default->pollutionCardCommunity',
        },
        {
          order: 2,
          className: 'px-1 pt-1_5',

          type: 'card',
          gradientBorder: false,
          subtype: 'selfSufficiencyCardCommunity',
          id: 'selfSufficiencyCardCommunity',
          totalValue: 'self_sufficiency_rate',
          icon: 'self_sufficiency',
          descriptionType: 'label',
          description: 'widgets.selfSufficiencyCardCommunity.description',
          details: {
            type: 'description',
            title: 'widgets.selfSufficiencyCardCommunity.details.title',
            label: 'widgets.selfSufficiencyCardCommunity.details.label',
            totalValue: 'self_sufficiency_rate',
          },
          devID: 'waggish-dragon',
          devPath: 'community->default->selfSufficiencyCardCommunity',
        },
        {
          order: 4,
          className: 'px-1 pt-1_5',

          type: 'card',
          gradientBorder: false,
          subtype: 'savingsCardCommunity',
          id: 'savingsCardCommunity',
          totalValue: 'revenues',
          kpiContext: 'economics',
          icon: 'savings',
          descriptionType: 'label',
          description: 'widgets.savingsCardCommunity.description',
          details: {
            type: 'detailed',
            title: 'widgets.savingsCardCommunity.details.title',
            totalValue: 'revenues',
            label: 'widgets.savingsCardCommunity.details.label',
            data: [
              {
                label: 'widgets.savingsCardCommunity.details.label_1',
                value: 'public_incentive',
              },
              {
                label: 'widgets.savingsCardCommunity.details.label_2',
                value: 'charge_reduction',
              },
            ],
          },
          devID: 'bizarre-shoe',
          devPath: 'community->default->savingsCardCommunity',
        },
        {
          order: 5,
          className: 'px-1 pt-1_5',

          type: 'graphs',
          gradientBorder: false,
          subtype: 'savingsStackbar',
          id: 'savingsStackbar',
          totalValue: 'total_benefits',
          kpiContext: 'economics',
          graphKeys: [
            {
              key: 'revenues',
              color: 'revenues',
              combined: false,
            },
          ],
          colors: ['economics'],
          title: 'widgets.savingsStackbar.title',
          devID: 'zealous-nacho',
          devPath: 'community->default->savingsStackbar',
        },
        {
          order: 6,
          className: 'px-1 pt-1_5',
          type: 'areachart',
          gradientBorder: false,
          subtype: 'areachart',
          id: 'areachart',
          graphKeys: ['consumption', 'production', 'total_shared'],
          colors: ['consumption', 'production', 'self_consumption'],
          title: 'widgets.areaChart.title',
          devID: 'peculiar-marshmallow',
          devPath: 'community->default->areachart',
        },
        {
          order: 9999,
          type: 'footer',
          subtype: 'footer',
          id: 'footer',
          sections: ['household', 'community'],
          devID: 'daring-espresso',
          devPath: 'community->default->footer',
        },
      ],
    },
  },
];
